import { FC } from 'react';

import { FCWithChildren } from 'common/types';

import {
  Description,
  Icon,
  IconContainer,
  StepChildren,
  StepContent,
  Title,
  TrailingLine,
  Wrapper,
} from './styles';
import { IconProps, StepProps } from './types';

const StepIcon: FC<IconProps> = ({ hasTrailingLine, src }) => (
  <IconContainer>
    <Icon src={src} />
    {hasTrailingLine ? <TrailingLine /> : null}
  </IconContainer>
);

const Step: FCWithChildren<StepProps> = ({
  children,
  description,
  hasTrailingLine = true,
  icon,
  title,
}) => (
  <>
    <StepIcon hasTrailingLine={hasTrailingLine} src={icon} />

    <StepContent>
      <Title>{title}</Title>

      {description ? <Description>{description}</Description> : null}

      {children ? <StepChildren>{children}</StepChildren> : null}
    </StepContent>
  </>
);

const Timeline: FCWithChildren & { Step: typeof Step } = ({
  children,
  ...props
}) => <Wrapper {...props}>{children}</Wrapper>;

Timeline.Step = Step;

export default Timeline;
